import "./styles.module.css";
import { useEffect, useState } from "react";
import apiHelpers from "../../utils/api-helpers";
import { get } from "lodash";
import Title from "./title";
import VerticalCardComponent from "./verticle-card-component";
import MiddleEastBgDesktop from "../../../../assets/img/middle-east-bg-desktop.png";
import MiddleEastBgMobile from "../../../../assets/img/middle-east-bg-mobile.png";
import { helpers } from "../../utils/helpers";

const MiddleEast = ({ token }) => {
  const [stories, setStories] = useState([]);
  const isDesktop = helpers.isDesktop();
  const fetchStories = async () => {
    try {
      const endpoint = "/home-page/middle-east";
      const body = {};
      const response = await apiHelpers.apiRequest(endpoint, body, "POST");
      if (response.success) {
        const latestStories = get(
          response,
          ["data", "latest_stories", "data"],
          []
        );
        const spotlightStory = get(
          response,
          ["data", "spotlight_stories", "data"],
          []
        );
        setStories([...latestStories, ...spotlightStory]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    console.log("Middle east section");
    fetchStories();
  }, []);

  return (
    <div className="middle-east-container">
      <div className="middle-east-container-inner">
        <Title title="Middle East" />
        <div className="middle-east-container-stories">
          {stories.map((story, index) => (
            <VerticalCardComponent
              story={story}
              key={story.id}
              showImage={isDesktop ? true : index === 0}
              showStrap={isDesktop ? true : index === 0}
            />
          ))}
        </div>
      </div>
      <div className="middle-east-container-bg-desktop">
        <img src={MiddleEastBgDesktop} alt="middle-east-bg" />
      </div>
      <div className="middle-east-container-bg-mobile">
        <img src={MiddleEastBgMobile} alt="middle-east-bg" />
      </div>
    </div>
  );
};

export default MiddleEast;
